module.exports = __webpack_public_path__ + "img/my_wishlist.01a7fe1e.png";